export const Wallet = {
  apple_pay: "apple_pay",
  google_pay: "google_pay",
} as const;

export type Wallet = keyof typeof Wallet;

export const WalletDisplayName: Record<Wallet, string> = {
  apple_pay: "Apple pay",
  google_pay: "Google pay",
};
